let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iZ4Cd")).then(() => parcelRequire('kFL29'));